import { Col, Row, Tooltip } from 'react-bootstrap';
import { Input } from 'antd';
import LinkButton from 'components/shared/button/LinkButton';
import { ReactSelect } from 'components/shared/dropdown/GNESingleSelect';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import { useState, useImperativeHandle, forwardRef } from 'react';
import './TabHeader.scss';
import { INSIGHT_TYPE, NUMBER_ZERO } from 'constants/constants';

const TabHeader = forwardRef(
  ({ page, filterViewOptions, handleSearch }, ref) => {
    const { Search } = Input;
    const [searchedText, setSearchedText] = useState('');
    const [selectedDropdownValue, setSelectedDropdownValue] = useState(
      filterViewOptions[NUMBER_ZERO]
    );

    const tooltip = () => {
      return (
        <Tooltip className='gne-tooltip'>
          <span className='text text__x-small'>
            If you'd like to submit your insight board for availability to C360
            users, please submit a ticket by clicking the Help button at the top
            right and selecting "Raise Request". We will get in touch with you
            and assist in publishing it as a sample insight board.
          </span>
        </Tooltip>
      );
    };

    const handleClear = () => {
      setSearchedText('');
      setSelectedDropdownValue(filterViewOptions[NUMBER_ZERO]);
      handleSearch('', filterViewOptions[NUMBER_ZERO]?.value);
    };

    const handleDropdownChange = (value) => {
      setSelectedDropdownValue(value);
      handleSearch(searchedText, value.value);
    };

    // Expose handleClear function to parent component
    useImperativeHandle(ref, () => ({
      clearSearch: handleClear,
    }));

    return (
      <Row className='align-items-center mt-4'>
        <Col
          sm={4}
          className='ps-0'>
          <Search
            width={1000}
            type='text'
            value={searchedText}
            onSearch={() =>
              handleSearch(searchedText, selectedDropdownValue.value)
            }
            onChange={(e) => setSearchedText(e.target.value)}
            onClear={handleClear}
            className='gne-search text text__small search-lg'
            placeholder={
              page === INSIGHT_TYPE.GENERAL
                ? 'Search by Name or Customer Type'
                : 'Search by Name, Publisher, or Customer Type'
            }
          />
        </Col>
        <Col
          sm={page === INSIGHT_TYPE.GENERAL ? 6 : 4}
          className='ps-0'>
          <LinkButton
            onClick={handleClear}
            className='title title__small'>
            Clear Results
          </LinkButton>
        </Col>
        <Col
          sm={page === INSIGHT_TYPE.GENERAL ? 2 : 4}
          className='pe-0'>
          {page === INSIGHT_TYPE.GENERAL ? (
            <div>
              <ReactSelect
                onChange={handleDropdownChange}
                value={selectedDropdownValue}
                options={filterViewOptions}
                placeholder={'All Insights Board'}
                className='single-select text text__small'
              />
            </div>
          ) : (
            <div className='text-end'>
              <OverlayTrigger
                overlay={tooltip()}
                placement='bottom'>
                <i className={`icon icon__info_icon-yellow`} />
              </OverlayTrigger>
              <span className='text text__bold text__small mb-4 '>
                Submit Your Insight Boards
              </span>
            </div>
          )}
        </Col>
      </Row>
    );
  }
);

export default TabHeader;
